import { connect } from 'react-redux';
import CreateInvoiceRutin from '../../../../views/Finance/Spp/CreateInvoice/CreateInvoiceRutin.view';
import { getStudent } from '../../../../states/thunks/student.thunk';
import { saveInvoiceRutin } from '../../../../states/thunks/academics.thunk'
import { getYearsOfEducationsOptions, getPrmPayments } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    result: state.result,
  }
}

function mapDispatchToProps(dispatch){
  return{
    handleGetStudent: () => dispatch(getStudent()),
    handleSaveInvoiceRutin: (payload, goback) => dispatch(saveInvoiceRutin(payload, goback)),
    getYearsOfEducationsOptions: (payload) => dispatch(getYearsOfEducationsOptions(payload)),
    getPrmPayments: (payload) => dispatch(getPrmPayments(payload)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps) (CreateInvoiceRutin);